import { Configuration, Fetcher } from "swr/dist/types";

export const defaultSWROptions: Partial<Configuration<any, any, Fetcher<any>>> = {
  revalidateOnFocus: false,
  shouldRetryOnError: false
};
